module.exports = __webpack_public_path__ + "img/maltlogomono.1fcefab2.webp";